import moment from "moment";

export function getTempoResposta(createdAt, finalizadoData) {
  const createdAtMoment = moment(createdAt);
  const finalizadoDataMoment = moment(finalizadoData);

  const duracao = moment.duration(finalizadoDataMoment.diff(createdAtMoment));

  let tempoEspera = '';

  // Se a duração for maior ou igual a 1 dia
  if (duracao.days() >= 1) {
    tempoEspera = `${duracao.days()} dias`;
  } 
  // Se a duração for maior ou igual a 1 hora mas menor que 1 dia
  else if (duracao.hours() >= 1) {
    tempoEspera = `${duracao.hours()} horas`;
  } 
  // Se a duração for menor que 1 hora
  else if (duracao.minutes() >= 1) {
    tempoEspera = `${duracao.minutes()} minutos`;
  } 
  // Se for menor que 1 minuto
  else {
    tempoEspera = 'Menos de 1 minuto';
  }

  return tempoEspera;
}
